import { useTranslation } from "@outschool/localization";

import { REASONS } from "../../../shared/EnrollmentPaymentRefund";

export const useParentRefundReasonLabels = (section?: {
  is_self_paced: boolean;
}) => {
  const { t } = useTranslation(
    "client\\components\\account\\useParentRefundReasonLabels",
  );

  if (section?.is_self_paced) {
    return {
      [REASONS.LEARNER_NO_FINISH]: t(
        "My learner does not want to finish this class",
      ),
      [REASONS.LOW_VALUE]: t(
        "Do not feel this class is delivering enough value",
      ),
      [REASONS.PARENT_CLASS_LEVEL]: t(
        "This class was the wrong level (too hard or too easy)",
      ),
      [REASONS.POOR_QUALITY]: t("Poor audio or video quality"),
      [REASONS.PARENT_BUDGET]: t("Budget reasons"),
      [REASONS.UNRESPONSIVE_TEACHER]: t("Unresponsive teacher"),
      [REASONS.OTHER]: t("Other"),
    };
  }

  return {
    [REASONS.PARENT_DISSATISFIED_TEACHER_CLASS]: t(
      "This teaching style, class format, or topic was not a good fit for us",
    ),
    [REASONS.PARENT_SCHEDULE]: t("We have a schedule conflict"),
    [REASONS.PARENT_SKIP]: t("We would just like to skip a week or two"),
    [REASONS.PARENT_BUSY]: t("We are too busy right now"),
    [REASONS.PARENT_CLASS_LEVEL]: t(
      "This class was the wrong level (too hard or too easy)",
    ),
    [REASONS.PARENT_NOT_INTERESTED]: t("We are ready to try something new"),
    [REASONS.PARENT_BUDGET]: t("Budget reasons"),
    [REASONS.PARENT_TRIAL]: t(
      "We were only trying it out or dropping in temporarily",
    ),
    [REASONS.OTHER]: t("Other"),
  };
};
